import { render } from "./DynamicEditor.vue?vue&type=template&id=36f6d9e4&ts=true"
import script from "./DynamicEditor.vue?vue&type=script&lang=ts"
export * from "./DynamicEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36f6d9e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36f6d9e4', __exports__)) {
    api.reload('36f6d9e4', __exports__)
  }
  
  module.hot.accept("./DynamicEditor.vue?vue&type=template&id=36f6d9e4&ts=true", () => {
    api.rerender('36f6d9e4', render)
  })

}


export default __exports__